export enum DeviceUseStatementCode {
  relay = 'deviceusestatement.relay',
  patch = 'deviceusestatement.patch',
  band = 'deviceusestatement.band',
  glucose = 'deviceusestatement.glucose',
  bloodPressure = 'deviceusestatement.bloodPressure',
}
